import styles from './SearchOverlay.module.scss';

export const SearchOverlay = () => {
  return <div id="search__overlay" className={styles.search__overlay}></div>;
};
